// src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import './styles/global.css'; 

// Component Imports
import Header from './components/Header';
import Footer from './components/Footer'; 

// Page Components
import Home from './components/Home';             
import Onboarding from './components/onboarding/Onboarding'; 
import Results from './components/Results';

// Other Pages
import Explore from './components/Explore';               
import ResourcesPage from './components/ResourcesPage';   
import HowItWorksPage from './components/HowItWorksPage'; 
import Login from './components/Login';                   
import Signup from './components/Signup';                 
import PathPage from './components/PathPage'; 
import Dashboard from './components/Dashboard'; // ⬅️ NEW: Import the Dashboard component


const App = () => {
  return (
    <Router>
      <div className="app-container">
        <Header />

        <main className="main-content">
          <Routes>
            {/* Core Flow Pages */}
            <Route path="/" element={<Home />} /> 
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/results" element={<Results />} /> 

            {/* Navigation Bar Pages */}
            <Route path="/explore" element={<Explore />} />
            
            {/* Dynamic Route for Career Path Pages */}
            <Route path="/explore/:pathSlug" element={<PathPage />} /> 
            
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />

            {/* User Dashboard */}
            <Route path="/dashboard" element={<Dashboard />} /> {/* 🎯 NEW: Dashboard Route */}

            {/* Authentication Pages */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
};

export default App;
